import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

export const CONSENT_TEXT =
  "I have read and agree to the Terms & Conditions and understand that the Free Custom Website Program requires a six-month hosting and maintenance agreement at $200 per month. I understand that development will not begin until the agreement is signed and the first monthly payment is received.";

export default function ConsentCheckbox({ checked, onChange, testid = "consent-checkbox" }) {
  return (
    <label
      data-testid={`${testid}-label`}
      className={`flex items-start gap-3 rounded-xl px-4 py-3.5 border cursor-pointer transition-all text-sm ${
        checked
          ? "border-blue-500/60 bg-blue-500/10"
          : "border-white/10 bg-white/[0.03] hover:border-white/20"
      }`}
    >
      <Checkbox
        checked={checked}
        onCheckedChange={onChange}
        data-testid={testid}
        className="mt-0.5 h-5 w-5 border-2 border-blue-400 bg-white/5 data-[state=checked]:bg-blue-500 data-[state=checked]:border-blue-500 data-[state=checked]:text-white"
      />
      <span className="text-gray-300 leading-relaxed">
        I have read and agree to the{" "}
        <Link
          to="/terms"
          target="_blank"
          rel="noreferrer"
          className="text-blue-300 underline underline-offset-2 hover:text-blue-200"
          data-testid={`${testid}-terms-link`}
        >
          Terms &amp; Conditions
        </Link>{" "}
        and understand that the Free Custom Website Program requires a six-month
        hosting and maintenance agreement at{" "}
        <span className="text-white font-medium">$200 per month</span>. I
        understand that development will not begin until the agreement is signed
        and the first monthly payment is received.
      </span>
    </label>
  );
}
